/**
 * Market terminal local preferences: watched symbols, selected symbol, and
 * chart interval. Server-side alert thresholds live in MarketWatchItem.
 */
const PAIRS_KEY = "edgehub-market-pairs";
const SELECTED_KEY = "edgehub-market-selected";
const INTERVAL_KEY = "edgehub-market-interval";

export const DEFAULT_PAIRS = ["EURUSD", "GBPUSD", "USDJPY", "XAUUSD", "US500", "NAS100", "JP225", "GER40", "BTCUSD"];
export const INTERVALS = [
  { value: "1min", label: "1m" },
  { value: "5min", label: "5m" },
  { value: "15min", label: "15m" },
  { value: "1h", label: "1H" },
  { value: "4h", label: "4H" },
  { value: "1day", label: "1D" },
  { value: "1week", label: "1W" },
  { value: "1month", label: "1M" },
];

function readJson(key, fallback) {
  try {
    const parsed = JSON.parse(localStorage.getItem(key) || "null");
    return parsed ?? fallback;
  } catch {
    return fallback;
  }
}

export const readPairs = () => {
  const saved = readJson(PAIRS_KEY, null);
  return Array.isArray(saved) ? saved.slice(0, 30) : [];
};
export const savePairs = pairs => localStorage.setItem(PAIRS_KEY, JSON.stringify(pairs.slice(0, 30)));

export const readSelected = fallback => {
  const saved = readJson(SELECTED_KEY, null);
  return typeof saved === "string" && saved ? saved : fallback;
};
export const saveSelected = symbol => localStorage.setItem(SELECTED_KEY, JSON.stringify(symbol));

export const readInterval = () => {
  const saved = readJson(INTERVAL_KEY, null);
  return INTERVALS.some(item => item.value === saved) ? saved : "1day";
};
export const saveInterval = interval => localStorage.setItem(INTERVAL_KEY, JSON.stringify(interval));
